export default __webpack_public_path__ + "static/media/Tome of the Black Gale.91755181.jpg";